module.exports = __webpack_public_path__ + "media/images/payments/amazon-89e7a1201a352eb37f9f11568dc08411.svg";